const airParadise = {
  assetFolder: "airParadise",
  B2BOnly: false,
  serviceAvailed: "1,2",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const triumphTravel = {
  assetFolder: "triumphhTravel",
  B2BOnly: true,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: true,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const easyMyTravels = {
  assetFolder: "easyTravels",
  B2BOnly: true,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const lookMyTicket = {
  assetFolder: "lookMyTicket",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const afaTours = {
  assetFolder: "afaTours",
  B2BOnly: false,
  serviceAvailed: "1,2",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const dwc = {
  assetFolder: "dwc",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const doneTrip = {
  assetFolder: "doneTrip",
  B2BOnly: false,
  serviceAvailed: "1,2",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const easyTravelsOnline = {
  assetFolder: "EasyTravelsOnline",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const tripBouquet = {
  assetFolder: "tripBouquet",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const buzzHolidays = {
  assetFolder: "BuzzHolidays",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const tickat = {
  assetFolder: "Tickat",
  B2BOnly: false,
  serviceAvailed: "1,2,4,6",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: false,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: false,
  refreshToken: false
};

const gostree = {
  assetFolder: "gostree",
  B2BOnly: true,
  serviceAvailed: "1,2,4,13,17,18,19,21,22,25",
  hotelInfoCarouselButtonLarge: true,
  commonHomeLogin: true,
  ajaxFlightSearch: false,
  balanceRefreshInterval: false,
  showDsaContact: true,
  refreshToken: true
};

export const AppConstant = gostree;
